import AllCountries from '../components/common/phoneInput/components/AllCountries';

export const setFieldValue = (form, name, value) => {
  if (form) {
    const fixname = [];
    if (typeof name == 'object') {
      name.forEach((node) => {
        fixname.push(node);
      });
    } else {
      fixname.push(String(name));
    }
    let fieldsValue;
    fixname.reverse().forEach((node) => {
      fieldsValue = {
        [String(node)]: fieldsValue !== undefined ? fieldsValue : value,
      };
    });
    form.setFieldsValue(fieldsValue);
  }
};

const ALL_COUNTRIES = AllCountries.getCountries();
export const getPhoneValue = (phone = '', countryCode) => {
  const code = phone?.slice(0, 3) || '';
  const country = ALL_COUNTRIES.find((_) => `+${_?.dialCode}` === code) || {};
  return {
    country: country?.iso2 || countryCode?.toLowerCase() || '',
    code,
    number: phone?.slice(3, phone.length) || '',
  };
};


export const formatDateServer = (date)=>{
  return date ? date.replace('Z', '+00:00') : null
}
